import { selectAppData } from './common'

const selectQuote = (state) => selectAppData(state).quote

export const selectQuoteRestrictions = (state) => selectQuote(state).quoteRestrictions
